import classnames from 'classnames';
import { MouseEventHandler, useCallback } from 'react';

import styles from './Badge.module.scss';
import { BadgeProps } from './Badge.types';

export const Badge = ({
  color,
  saturation = 'full',
  size = 'small',
  className,
  clickable,
  children,
  onClick,
  ...props
}: BadgeProps) => {
  const handleClick = useCallback<MouseEventHandler<HTMLDivElement | HTMLButtonElement>>(
    event => {
      const target = event.target as HTMLElement;
      if (target.matches(`button:not(.${styles.badge}), button:not(.${styles.badge}) *`))
        return event.preventDefault();
      onClick?.(event);
    },
    [onClick]
  );

  if (clickable)
    return (
      <button
        data-icon-size={
          size === 'xxsmall'
            ? 'xxsmall'
            : size === 'xsmall'
              ? 'xxsmall'
              : size === 'small'
                ? 'xsmall'
                : size === 'medium'
                  ? 'small'
                  : 'medium'
        }
        type="button"
        className={classnames(
          styles.badge,
          styles.clickable,
          className,
          styles[color],
          styles[('saturation-' + saturation) as `saturation-${typeof saturation}`],
          styles[size]
        )}
        onClick={handleClick}
        {...props}
      >
        <span className={styles.children}>{children}</span>
      </button>
    );
  return (
    <div
      data-icon-size={
        size === 'xxsmall'
          ? 'xxsmall'
          : size === 'xsmall'
            ? 'xxsmall'
            : size === 'small'
              ? 'xsmall'
              : size === 'medium'
                ? 'small'
                : 'medium'
      }
      className={classnames(
        styles.badge,
        className,
        styles[color],
        styles[('saturation-' + saturation) as `saturation-${typeof saturation}`],
        styles[size]
      )}
      onClick={handleClick}
      {...props}
    >
      <span className={styles.children}>{children}</span>
    </div>
  );
};
